import script from "./DayReviewChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DayReviewChart.vue?vue&type=script&setup=true&lang=js"

import "./DayReviewChart.vue?vue&type=style&index=0&id=41072255&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41072255"]])

export default __exports__